import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthCheck } from '../auth/auth.check';
import { AutoHealComponent } from './auto-heal/auto-heal.component';
import { AwsSettingComponent } from './aws-setting/aws-setting.component';
import { PartyIntegrationComponent } from './party-integration/party-integration.component';
import { ProjectSettingComponent } from './project-setting/project-setting.component';


const routes: Routes = [
  {
    path: 'project-setting/:pid', component: ProjectSettingComponent
    ,canActivate:[AuthCheck]},
  {
    path: 'aws-setting/:pid', component: AwsSettingComponent
    ,canActivate:[AuthCheck]}
  ,
  {
    path: 'auto-heal/:pid', component: AutoHealComponent
    ,canActivate:[AuthCheck]}
  ,
  {
    path: '3rd-party-integration/:pid', component: PartyIntegrationComponent
    ,canActivate:[AuthCheck]}

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingRoutingModule { }
